module.exports = __webpack_public_path__ + "assets/img/occ.adf08641.png";